// extracted by mini-css-extract-plugin
module.exports = {"notificationCard":"CraneNotification_notificationCard__3o0hI","content":"CraneNotification_content__1KuZI","time":"CraneNotification_time__20UeL"};